import * as Utils from "../Utils";
import FloodgateStorageProvider from "../FloodgateCore/FloodgateStorageProvider";
import { TmsCache } from "../TargetedMessaging/tmscache";
import { ContentType } from "../TargetedMessaging/tmsContentType";

export const enum SettingKey {
	logLevelSettings = "LogLevelSettings",
	webSurfacesLink = "WebSurfacesLink",
	tmsServiceUrl = "TmsServiceUrl",
	tmsActionUrl = "TmsActionUrl",
	tmsLoadTimeout = "TmsLoadTimeout"
}

let dynamicSettingsTmsCache: TmsCache = null;

export function getDynamicSetting<T>(key: SettingKey, defaultValue: T): T {
	if (!dynamicSettingsTmsCache && FloodgateStorageProvider.isStorageAvailable()) {
		dynamicSettingsTmsCache =  new TmsCache([ContentType.dynamicSettings]);
	}

	if (!dynamicSettingsTmsCache) {
		return defaultValue;
	}

	const cacheItem = dynamicSettingsTmsCache.getItem(ContentType.dynamicSettings);
	const settingsObj = cacheItem && cacheItem.content;
	if (!Utils.isNullorUndefined(settingsObj)
		&& settingsObj.hasOwnProperty(key)
		&& !Utils.isNullorUndefined(settingsObj[key])) {
		return settingsObj[key];
	}

	return defaultValue;
}

export function resetDynamicSettingsTmsCache() {
	dynamicSettingsTmsCache = null;
}
